import { Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { useState } from "react";
import { PersonRemove, PersonAdd } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getNewJournalErros } from '../util/validation_utilities';
import { newJournalSchema } from "../Validations/new_journal_validation";
import axiosInstance from "../util/axios_instance";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function NewJournal() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        journalTitle: '',
        timeCapsuleConfiguration: {
            deliveryDate: '',
            closeContacts: [{
                email: '',
                relationship: ''
            }]
        }
    })

    const handleChange = (event) => {

        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleNestedChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            timeCapsuleConfiguration: {
                ...prevData.timeCapsuleConfiguration,
                [name]: value
            }
        }));
    };

    const handleCloseContactChange = (index, e) => {
        const { name, value } = e.target;
        const updatedCloseContactArray = formData.timeCapsuleConfiguration.closeContacts.map((closeContact, i) =>
            i === index ? { ...closeContact, [name]: value } : closeContact
        );

        setFormData((prevData) => ({
            ...prevData,
            timeCapsuleConfiguration: {
                ...prevData.timeCapsuleConfiguration,
                closeContacts: updatedCloseContactArray
            }
        }));
    }

    const saveJournal = async (e) => {
        e.preventDefault();
        try {
            await newJournalSchema.validate(formData, { abortEarly: false });
            setErrors({});            
            const response = await axiosInstance.post(`${BACKEND_HOST}/journal/create`, formData, {
                withCredentials: true
            })
            if (response.status === 200) {
                navigate('/journals');
            }
        } catch (validationErrors) {
            if(validationErrors.status === 400){
                toast.error(validationErrors.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            } else {
                let err = getNewJournalErros(validationErrors);
                setErrors(err);
            }
        }
    }
    const handleAddField = () => {
        setFormData((prevData) => ({
            ...prevData,
            timeCapsuleConfiguration: {
                ...prevData.timeCapsuleConfiguration,
                closeContacts: [...prevData.timeCapsuleConfiguration.closeContacts, { email: '', relationship: '' }]
            }
        }));
    };

    const handleRemoveField = (index) => {
        const updatedZipArray = formData.timeCapsuleConfiguration.closeContacts.filter((_, i) => i !== index);
        setFormData((prevData) => ({
            ...prevData,
            timeCapsuleConfiguration: {
                ...prevData.timeCapsuleConfiguration,
                closeContacts: updatedZipArray
            }
        }));
    };

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                />
            <form onSubmit={saveJournal} >
                <Box display="flex"
                    flexDirection={"column"}
                    width="50vw" // Set width to 50% of the viewport width
                    maxWidth={1024} alignItems={'center'}
                    justifyContent={'center'}
                    margin={'auto'}
                    marginTop={5}
                    padding={3}
                    borderRadius={5}
                    boxShadow={"5px 10px 10px #ccc"}
                    sx={{
                        ":hover": {
                            boxShadow: "10px 10px 20px #ccc",
                        }
                    }}>
                    <Typography variant='h2' padding={3} textAlign={'center'}>New Journal</Typography>

                    <TextField
                        margin='normal'
                        variant='outlined'
                        name='journalTitle'
                        placeholder='Journal Title'
                        value={formData.journalTitle}
                        onChange={handleChange}>
                    </TextField>
                    {errors.journalTitle && <div style={{ color: 'red' }}>{errors.journalTitle}</div>}

                    <TextField
                        margin='normal'
                        type='text'
                        variant='outlined'
                        name='deliveryDate'
                        placeholder='Dilevery Date'
                        value={formData.timeCapsuleConfiguration.deliveryDate}
                        onChange={handleNestedChange}>
                    </TextField>
                    {errors["timeCapsuleConfiguration.deliveryDate"] && <div style={{ color: 'red' }}>{errors["timeCapsuleConfiguration.deliveryDate"]}</div>}

                    {formData.timeCapsuleConfiguration.closeContacts.map((field, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <TextField
                                name="email"
                                label="Email"
                                variant="outlined"
                                value={field.email}
                                onChange={(event) => handleCloseContactChange(index, event)}
                                style={{ marginRight: '10px' }} />
                            {errors[`timeCapsuleConfiguration.closeContacts[${index}].email`] && <div style={{ color: 'red' }}>{errors[`timeCapsuleConfiguration.closeContacts[${index}].email`]}</div>}

                            <TextField
                                name="relationship"
                                label="Relationship"
                                variant="outlined"
                                value={field.relationship}
                                onChange={(event) => handleCloseContactChange(index, event)}
                                style={{ marginRight: '10px' }} />
                            {errors[`timeCapsuleConfiguration.closeContacts[${index}].relationship`] && <div style={{ color: 'red' }}>{errors[`timeCapsuleConfiguration.closeContacts[${index}].relationship`]}</div>}
                            <IconButton color="secondary" width={1} onClick={() => handleRemoveField(index)}>
                                <PersonRemove />
                            </IconButton>
                        </div>
                    ))}
                    <IconButton variant="contained" color="primary" onClick={handleAddField}>
                        <PersonAdd />
                    </IconButton>
                    <Button type='submit' sx={{ marginTop: 3, borderRadius: 3 }} variant='contained'>Save Journal</Button>
                </Box>
            </form>
        </div>
    )
}

export default NewJournal;